module.exports = __webpack_public_path__ + "img/reserve.a391709e.png";